const Index = () => import("./index.vue");
const CreatePage = () => import("./_pages/create.vue");
const ViewPage = () => import("./_pages/view.vue");

export default [
  {
    path: "/lipa-pole-pole",
    component: Index,
  },
  {
    path: "/lipa-pole-pole/:id",
    component: ViewPage,
  },
  {
    path: "/new-lipa-pole-pole-record",
    component: CreatePage,
  },
];
